class PageTitle {
    constructor() {
        this._title = document.title;
    }

    change(newTitle) {
        sessionStorage.setItem('last-title', document.title);
        document.title = newTitle;
    }

    restoreLast() {
        document.title = sessionStorage.getItem('last-title') || this._title;
    }
}

export default PageTitle;
